export default "__VITE_ASSET__DxlhBN1o__";